<template>
  <div class="chart-block">
    <h3>
      {{ chartName }}
      <span>{{ updated }}</span>
    </h3>
    <div id="chart_cmnc" class="chart-box" loading></div>
  </div>
</template>
<script>
import echarts from "echarts";
import { mapMutations, mapGetters, mapActions, mapState } from "vuex";
export default {
  props: {
    chartName: {
      type: String,
      default: "申请通过率",
    },
  },
  data() {
    return {
      loading: true,
      tip: "申请通过率",
      chartOption: {},
      updated: "",
      dataDate: "",
      marketType: "申请通过率",
      chartId: "current_month_count",
    };
  },
  mounted() {
    let icon =
      "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAE4AAAAwCAYAAAC/gkysAAABhElEQVRoge3avS6EQRTG8eMjIjQ6FKJ3A25CJxqVWq3aZWYawg3odKpzdsNGQjYhW+hUCnELzHlthA2FZhQSH8mbiFdi9sRzkn//zK8eok8XDu4nvOimF2171hsvmv51rDdO9DiIrgfWKSq7IMWCk3iXfWwfF1hXvqKxruQeZSXXiItERFRrxUnH+pJ7kJk4dtfat+PkRLezjzFWkLhGjvUy9xBrOdYLcqKPuYdYjHIPsBrgAAc4EwEOcIAzEeAABzgTAQ5wgDMR4AAHOBMBDnCAMxHgAAc4EwEOcIAzEXnWXu4RFiMn8Sr3CGs51mtyolu5h9ir2KFas5jOP8RS8al+2J3Bj8wf9v4j8+MPcFzNPaqfcxyfAxfL5R+ouTvnuNj1rA+5h/ZNrD3PsVVv3s+WouU6L7r324dtNO7mc7/j7y+lASdxH2gVLqQ06FkFaBVuidOQ59gCWoULnTT8LR7Qyu8NT0+AVuECpxHP8QxoFS500qhnPQdahQtHacxJPO1HtFerNkp+/CyOOAAAAABJRU5ErkJggg==";

    this.chartOption = {
      tooltip: {
        formatter: function (params, ticket, callback) {
          return "类型:" + params.name + "<br />申请：" + params.value + " 件";
        },
      },
      toolbox: {
        show: true,
        // feature: {
        //     dataView: {show: true, readOnly: false},
        //     magicType: {show: true, type: ['line', 'bar']},
        //     restore: {show: true},
        //     saveAsImage: {show: true}
        // }
      },
      title: {
        text: "单位：件",
        show: false,
        right: "5%",
        top: "30%",
        textStyle: {
          fontWeight: "normal",
          color: "#6a7e97",
        },
      },
      legend: {
        orient: "vertical",
        right: "5%",
        top: "46%",
        show: false,
      },
      grid: {
        left: "5%",
        right: "5%",
        bottom: "3%",
        containLabel: true,
      },
      xAxis: {
        type: "category",

        data: [
          "生物医药",
          "微电子",
          "汽车",
        
          // "价格调整"
        ],
        axisLabel: {
          //坐标轴刻度标签的相关设置。
          interval: 0, //设置为 1，表示『隔一个标签显示一个标签』
          //	margin:15,
          textStyle: {
            color: "#1B253A",
            fontStyle: "normal",
            fontFamily: "微软雅黑",
            fontSize: 12,
          },
          //  rotate:50,
        },
        axisTick: {
          //坐标轴刻度相关设置。
          show: false,
        },
        axisLine: {
          //坐标轴轴线相关设置
          lineStyle: {
            color: "#E5E9ED",
            // opacity:0.2
          },
        },
        splitLine: {
          //坐标轴在 grid 区域中的分隔线。
          show: false,
          lineStyle: {
            color: "#E5E9ED",
            // 	opacity:0.1
          },
        },
      },
      yAxis: {
        type: "value",
        axisLabel: {
          show: false,
        },
        axisLine: {
          show: false,
        },
        axisTick: {
          show: false,
        },
        splitLine: {
          show: false,
        },
      },
      series: [
        {
          name: "MPV",
          type: "pictorialBar",
          barGap: "100%",

          barWidth:'63px',
          symbol:
            "path://M72.43,111.16C57.08,111.16,48.42,0,36.22,0S15.35,111.16,0,111.16;",
          //  symbol: 'path://M0,10 L10,10 C5.5,10 5.5,5 5,0 C4.5,5 4.5,10 0,10 z',
          label: {
            normal: {
              show: true,
              position: "top",
              //字体颜色
              color: "#FFFFFF",
              backgroundColor: {
                image: icon,
              },

              /*borderRadius:12,*/
              padding: [5, 12, 5, 12],
            },
          },

          itemStyle: {
            normal: {
              color: "rgba(127,171,234,1)",
            },
          },
          data: [22,33, 15, 55, 12, 21],
        },
        {
          name: "SUV",
          type: "pictorialBar",
          barGap: "-60%",
          barWidth: "33px",
          symbol:
            "path://M72.43,111.16C57.08,111.16,48.42,0,36.22,0S15.35,111.16,0,111.16",
          itemStyle: {
            normal: {
              color: "rgba(175,200,243,0.9)",
            },
          },
          data: [41, 66, 42, 31, 15, 22],
        },
        {
          name: "Sedan",
          type: "pictorialBar",
          barGap: "-30%",
          barWidth: "33px",
          symbol:
            "path://M72.43,111.16C57.08,111.16,48.42,0,36.22,0S15.35,111.16,0,111.16",
          itemStyle: {
            normal: {
              color: "rgba(126,145,201,0.9)",
            },
          },
          data: [0, 46, 72, 11, 41, 35],
        },
      ],
    };
    this.updateChart();
 },
  methods: {
    ...mapActions("widgets", ["queryWidgetByName"]),

    updateChart() {
      var self = this;
      this.myChart = echarts.init(document.getElementById("chart_cmnc"));
      this.myChart.setOption(this.chartOption);
      window.addEventListener("resize", () => {
        this.myChart.resize();
      });
    },

    bindChart() {
      this.updated = `最新数据时间  `;

      this.chartOption.series.data = [];

      var x = this.jsonData.filter((x) => x.t == this.marketType);

      var dict = { 生物医药: 0, 汽车: 0, 微电子: 0};

      for (var item of x) {
        if (item.name == "NP") {
          dict["生物医药"] += item.value;
        } else if (item.name == "GP") {
          dict["生物医药"] += item.value;
        } else if (item.name == "NM") {
          dict["汽车"] += item.value;
        } else if (item.name == "MSRP") {
          dict["汽车"] += item.value;
        } else if (item.name == "MCE1") {
          dict["微电子"] += item.value;
        } else if (item.name.indexOf("MCE") > -1) {
          dict["微电子"] += item.value;
        }
      }
      for (let item in dict) {
        this.chartOption.series.data.push(dict[item]);
      }

      this.myChart.setOption(this.chartOption);
      this.loading = false;
    },
  },
  computed: {
    ...mapGetters("home", {
      chartList: "chartList",
      getChartByName: "getChartByName",
    }),
  },
  watch: {},
  created() {},
};
</script>
 